import React from 'react';
import TableHeader from '../TableHeader';
import moment from 'moment';
import LinkText from '../LinkText';
import KillPalButton from './KillPalButton';
import RevivePalButton from './RevivePalButton';

const NFTsList = ({
  nfts, type, total
}) => {
  return (
    <React.Fragment>
      <div className='MainHeader'>
        <div className='MainHeader__left'>
          <h2 className='MainHeader__h2'>{type}s list</h2>
          <p className='MainHeader__left__p'>Total {total.toLocaleString()} {type.toLowerCase()}s</p>
        </div>
      </div>

      <div className='Table Table--nft-list'>
        {(() => {
          let columnHeaders = [
            {
              label: 'ID',
              sortKey: 'id'
            },
            {
              label: 'Token id',
              sortKey: 'token_id'
            },
            {
              label: 'Bag id',
              sortKey: 'bag_id'
            },
            {
              label: 'Current earned EMPL',
              sortKey: 'current_empl_earned'
            }
          ]

          if(type == 'DeadPal') {
            columnHeaders.push({
              label: 'Died at',
              sortKey: 'died_at'
            })
          } else {
            columnHeaders.push({
              label: 'Deposited at',
              sortKey: 'deposited_at'
            })
          }

          columnHeaders.push({ label: 'Actions' })

          return (
            <div className='Table__row'>
              {columnHeaders.map((header, key) => (
                <TableHeader
                  key={key}
                  header={header}
                />
              ))}
            </div>
          )
        })()}

        {nfts.map((nft) => (
          <div className='Table__row' key={nft.id} data-x={nft}>
            <div className='Table__col'>
              <LinkText path={`nft/${nft.id}?type=${type}`} text={nft.id} />
            </div>
            <div className='Table__col'>{nft.tokenId}</div>
            <div className='Table__col'>
              <LinkText path={`bag/${nft.bagId}`} text={nft.bagId} />
            </div>
            <div className='Table__col'>{nft.currentEMPLEarned}</div>
            <div className='Table__col'>
              {
                type === 'DeadPal' ?
                  moment(nft.diedAt).format('YYYY-MM-DD HH:mm') :
                  moment.unix(nft.depositedAt).format('YYYY-MM-DD HH:mm')
              }
            </div>
            <div className='Table__col'>
              { (nft.diedAt) && <RevivePalButton tokenId={nft.tokenId} /> }
              { (!nft.diedAt && type != 'Egg') && <KillPalButton tokenId={nft.tokenId} /> }
            </div>
          </div>
        ))}
        {nfts.length == 0 && <div className='Table__row'>
          <div className='Table__col'>
            No result
          </div>
        </div>}
      </div>
    </React.Fragment>
  );
}

export default NFTsList;
